// OpenAI Token API Client
// API calls for managing encrypted OpenAI tokens in database

import { apiClient } from './api-client';

export interface SaveTokenResponse {
  success: boolean;
  message: string;
}

export interface GetTokenResponse {
  success: boolean;
  data: {
    token: string;
    updatedAt: string;
  };
}

/**
 * Save OpenAI token to database (encrypted)
 */
export async function saveOpenAIToken(token: string): Promise<SaveTokenResponse> {
  return apiClient.post<SaveTokenResponse>('/users/me/openai-token', { token });
}

/**
 * Get OpenAI token from database (decrypted)
 */
export async function getOpenAIToken(): Promise<GetTokenResponse> {
  return apiClient.get<GetTokenResponse>('/users/me/openai-token');
}

/**
 * Delete OpenAI token from database
 */
export async function deleteOpenAIToken(): Promise<SaveTokenResponse> {
  return apiClient.delete<SaveTokenResponse>('/users/me/openai-token');
}

/**
 * Check if user has OpenAI token saved
 */
export async function hasOpenAIToken(): Promise<boolean> {
  try {
    await getOpenAIToken();
    return true;
  } catch (error: any) {
    // 404 means no token found
    if (error?.response?.status === 404) {
      return false;
    }
    // Other errors (network, auth, etc.) - assume no token
    return false;
  }
}
